import { Button, FormControl, FormLabel, Grid2 } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import React from 'react'
import { i18n } from '../../index'
import { RestaurantOpeningHours } from '../types'
import { WEEKDAYS } from '../util'

interface Props {
  day: keyof RestaurantOpeningHours
  schedules: { opens: string; closes: string }[]
  opens: string
  closes: string
  setSchedules: (schedules: { opens: string; closes: string }[]) => void
}

function getDefaultSchedule(opens: string, closes: string): { opens: string; closes: string }[] {
  return [{ opens, closes }]
}

export default function MultipleTimeSelectRow({ day, schedules, opens, closes, setSchedules }: Props) {
  const initialSchedules = schedules.length > 0 ? schedules : getDefaultSchedule(opens, closes)
  const [displayedSchedules, setDisplayedSchedules] =
    React.useState<{ opens: string; closes: string }[]>(initialSchedules)

  const selectTime = (field: 'opens' | 'closes', time: string | null, index: number) => {
    const updatedSchedules = [...displayedSchedules]
    const scheduleToUpdate = updatedSchedules[index] || { opens: '00:00', closes: '00:00' }
    scheduleToUpdate[field] = time ?? '00:00'
    if (!updatedSchedules[index]) {
      updatedSchedules.push(scheduleToUpdate)
    }
    setDisplayedSchedules(updatedSchedules)
    setSchedules(updatedSchedules)
  }

  const addNewSchedule = () => {
    const newSchedule = { opens: '00:00', closes: '00:00' }
    const updatedSchedules = [...displayedSchedules, newSchedule]
    setDisplayedSchedules(updatedSchedules)
    setSchedules(updatedSchedules)
  }

  return (
    <Grid2 container direction='column' spacing={2}>
      <Grid2 container direction='row' spacing={2}>
        <Grid2 sx={{ minWidth: '150px' }}>
          <FormLabel>{i18n.t(`restaurantMenu.${WEEKDAYS[day].translationKey}`)}</FormLabel>
        </Grid2>
        <Grid2>
          <Button variant='contained' size='small' onClick={addNewSchedule}>
            {i18n.t('buttons.add')}
          </Button>
        </Grid2>
      </Grid2>
      {displayedSchedules.map((schedule, index) => (
        <Grid2 container direction='row' spacing={2} key={index}>
          <Grid2 sx={{ minWidth: '150px' }} />
          <Grid2>
            <FormControl>
              <TimePicker
                value={moment(schedule.opens, 'HH:mm')}
                onChange={(newValue) => selectTime('opens', newValue?.format('HH:mm') ?? null, index)}
              />
            </FormControl>
          </Grid2>
          <Grid2>
            <FormControl>
              <TimePicker
                value={moment(schedule.closes, 'HH:mm')}
                onChange={(newValue) => selectTime('closes', newValue?.format('HH:mm') ?? null, index)}
              />
            </FormControl>
          </Grid2>
        </Grid2>
      ))}
    </Grid2>
  )
}
